// IT-ALIAS-0411: legacy root URL /portal/order/it has no root React route. It is a noindex alias
// that sends visitors to the public IT request form; imported by App.tsx and generate-static-pages.mjs.
export const IT_ORDER_ALIAS_PATH = '/portal/order/it';
export const IT_ORDER_ALIAS_TARGET = '/en/start?type=it&from=portal-order-it&cta_id=portal-order-it-alias&page=%2Fportal%2Forder%2Fit';
export const IT_ORDER_ALIAS_CANONICAL = 'https://bpo-contact.com/en/start';
